import '@dbrainio/shared-ui/dist/index.css'
// import 'react-toastify/dist/ReactToastify.min.css'

import { useEffect } from 'react'
import Header from './components/Header/Header'

import { useSelector } from 'react-redux'
import { AppError, State } from './store/types'
import style from './App.module.css'
import GoogleLogin from './components/GoogleLogin/GoogleLogin'
import { GoogleLoginResponse } from 'react-google-login'
import { Client } from './@types/common'
import ClientsGridRoute from './components/ClientsGridRoute/ClientsGridRoute'
import { LocalStorage } from './utils/localStorage'
import { ToastContainer } from 'react-toastify'
import { Route, Routes, useNavigate } from 'react-router-dom'

function App() {
  const navigate = useNavigate()

  const googleToken = useSelector<State, string | null>(
    (state: State) => state.app.googleToken,
  )

  const appError = useSelector<State, AppError | undefined>(
    (state: State) => state.app.appError,
  )
  const handleLogin = (res?: GoogleLoginResponse) => {
    navigate('/manage')
    if (res) {
      LocalStorage.setGoogleAccount(res)
    }
  }

  useEffect(() => {
    if (appError === AppError.IncorrectToken) navigate('/')

    return () => {}
  }, [appError, navigate])

  return (
    <div className={style.layout}>
      <ToastContainer />
      <div className={style.header}>
        <Header isLoggedIn={!!googleToken} />
      </div>
      <Routes>
        <Route path="/" element={<GoogleLogin onLogin={handleLogin} />}>
          {/* <GoogleLogin onLogin={handleLogin} /> */}
        </Route>
        <Route path="/manage" element={<ClientsGridRoute />}></Route>
        <Route>Страница не найдена</Route>
      </Routes>
    </div>
  )
}

export default App
